import { __decorate, __param } from 'tslib';
import { EventEmitter, Inject, Input, Output, HostBinding, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TuiDay, ALWAYS_FALSE_HANDLER, TUI_FIRST_DAY, TUI_LAST_DAY, TuiMonth, TuiMonthRange, nullableSame, tuiDefaultProp, tuiPure, TuiLetModule, TuiHoveredModule, TuiPressedModule, TuiFocusableModule } from '@taiga-ui/cdk';
import { TUI_CALENDAR_MONTHS } from '@taiga-ui/kit/tokens';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TuiPrimitiveYearPickerModule, TuiPrimitiveSpinButtonModule, TuiScrollbarModule, TuiLinkModule } from '@taiga-ui/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@taiga-ui/cdk';
import * as ɵngcc4 from 'rxjs';

function TuiCalendarMonthComponent_tui_scrollbar_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-scrollbar", 2);
    ɵngcc0.ɵɵelementStart(1, "tui-primitive-year-picker", 3);
    ɵngcc0.ɵɵlistener("yearClick", function TuiCalendarMonthComponent_tui_scrollbar_0_Template_tui_primitive_year_picker_yearClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onPickerYearClick($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("min", ctx_r0.min)("max", ctx_r0.max)("initialItem", ctx_r0.year)("value", ctx_r0.value);
} }
function TuiCalendarMonthComponent_ng_template_1_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("tuiHoveredChange", function TuiCalendarMonthComponent_ng_template_1_ng_container_4_div_1_Template_div_tuiHoveredChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const item_r9 = restoredCtx.tuiLet; const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.onItemHovered($event, item_r9); })("tuiPressedChange", function TuiCalendarMonthComponent_ng_template_1_ng_container_4_div_1_Template_div_tuiPressedChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const item_r9 = restoredCtx.tuiLet; const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.onItemHovered($event, item_r9); })("click", function TuiCalendarMonthComponent_ng_template_1_ng_container_4_div_1_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const item_r9 = restoredCtx.tuiLet; const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.onItemClick(item_r9); });
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.tuiLet;
    const month_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("t-cell_today", ctx_r8.isItemToday(item_r9))("t-cell_interval", ctx_r8.isItemInsideRange(item_r9));
    ɵngcc0.ɵɵattribute("data-range", ctx_r8.getItemRange(item_r9))("data-state", ctx_r8.getItemState(item_r9));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(month_r6);
} }
function TuiCalendarMonthComponent_ng_template_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiCalendarMonthComponent_ng_template_1_ng_container_4_div_1_Template, 3, 7, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const index_r7 = ctx.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tuiLet", ctx_r5.getTuiMonth(index_r7, ctx_r5.year.year));
} }
function TuiCalendarMonthComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-primitive-spin-button", 4);
    ɵngcc0.ɵɵlistener("leftClick", function TuiCalendarMonthComponent_ng_template_1_Template_tui_primitive_spin_button_leftClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onPreviousYear(); })("rightClick", function TuiCalendarMonthComponent_ng_template_1_Template_tui_primitive_spin_button_rightClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onNextYear(); });
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function TuiCalendarMonthComponent_ng_template_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onYearClick(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtemplate(4, TuiCalendarMonthComponent_ng_template_1_ng_container_4_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵpipe(5, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("focusable", false)("leftDisabled", ctx_r2.previousYearDisabled)("rightDisabled", ctx_r2.nextYearDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tuiFocusable", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.year.formattedYear, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(5, 6, ctx_r2.months$));
} }
const TODAY = TuiDay.currentLocal();
// @dynamic
let TuiCalendarMonthComponent = class TuiCalendarMonthComponent {
    constructor(months$) {
        this.months$ = months$;
        this.value = null;
        this.year = TODAY;
        this.disabledItemHandler = ALWAYS_FALSE_HANDLER;
        this.min = TUI_FIRST_DAY;
        this.max = TUI_LAST_DAY;
        this.monthClick = new EventEmitter();
        this.hoveredItemChange = new EventEmitter();
        this.yearChange = new EventEmitter();
        this.isYearPickerShown = false;
        this.hoveredItem = null;
        this.pressedItem = null;
    }
    get isSingle() {
        return (this.value !== null &&
            (this.value instanceof TuiMonth || this.value.isSingleMonth));
    }
    get previousYearDisabled() {
        return this.year.yearSameOrBefore(this.min);
    }
    get nextYearDisabled() {
        return this.year.yearSameOrAfter(this.max);
    }
    getItemState(item) {
        const { disabledItemHandlerWithMinMax, pressedItem, hoveredItem } = this;
        if (disabledItemHandlerWithMinMax(item)) {
            return "disabled" /* Disabled */;
        }
        if (pressedItem !== null && pressedItem.monthSame(item)) {
            return "pressed" /* Pressed */;
        }
        if (hoveredItem !== null && hoveredItem.monthSame(item)) {
            return "hovered" /* Hovered */;
        }
        return null;
    }
    getItemRange(item) {
        const { value, hoveredItem } = this;
        if (value === null) {
            return null;
        }
        if (value instanceof TuiMonth) {
            return value.monthSame(item) ? "single" /* Single */ : null;
        }
        const theFirstOfRange = value.from.monthSame(item) && !value.isSingleMonth;
        const hoveredItemAfterFrom = hoveredItem !== null &&
            hoveredItem.monthAfter(value.from) &&
            value.from.monthSame(item) &&
            value.isSingleMonth;
        const hoveredItemIsCandidatToBeFrom = hoveredItem !== null &&
            hoveredItem.monthSame(item) &&
            hoveredItem.monthBefore(value.from) &&
            value.isSingleMonth;
        if (theFirstOfRange || hoveredItemAfterFrom || hoveredItemIsCandidatToBeFrom) {
            return "start" /* Start */;
        }
        const theLastOfRange = value.to.monthSame(item) && !value.isSingleMonth;
        const hoveredItemBeforeTo = hoveredItem !== null &&
            value.to.monthSame(item) &&
            hoveredItem.monthBefore(value.to) &&
            value.isSingleMonth;
        const hoveredItemIsCandidatToBeTo = hoveredItem !== null &&
            hoveredItem.monthSame(item) &&
            hoveredItem.monthAfter(value.from) &&
            value.isSingleMonth;
        if (theLastOfRange || hoveredItemBeforeTo || hoveredItemIsCandidatToBeTo) {
            return "end" /* End */;
        }
        return value.isSingleMonth && value.from.monthSame(item)
            ? "single" /* Single */
            : null;
    }
    getTuiMonth(monthNumber, yearNumber) {
        return new TuiMonth(yearNumber, monthNumber);
    }
    isItemToday(item) {
        return TODAY.monthSame(item);
    }
    isItemInsideRange(month) {
        const { value, hoveredItem } = this;
        if (value === null || value instanceof TuiMonth) {
            return false;
        }
        if (!value.isSingleMonth) {
            return value.from.monthSameOrBefore(month) && value.to.monthAfter(month);
        }
        if (hoveredItem === null) {
            return false;
        }
        const range = TuiMonthRange.sort(value.from, hoveredItem);
        return range.from.monthSameOrBefore(month) && range.to.monthAfter(month);
    }
    onPickerYearClick(year) {
        this.isYearPickerShown = false;
        if (this.year.yearSame(year)) {
            return;
        }
        this.year = year;
        this.yearChange.emit(year);
    }
    onItemClick(month) {
        if (this.disabledItemHandlerWithMinMax(month)) {
            return;
        }
        this.monthClick.emit(month);
    }
    onYearClick() {
        this.isYearPickerShown = true;
    }
    onNextYear() {
        this.year = this.year.append({ year: 1 });
    }
    onPreviousYear() {
        this.year = this.year.append({ year: -1 });
    }
    onItemHovered(hovered, item) {
        this.updateHoveredItem(hovered ? item : null);
    }
    onItemPressed(pressed, item) {
        this.updatePressedItem(pressed ? item : null);
    }
    calculateDisabledItemHandlerWithMinMax(disabledItemHandler, value, min, max) {
        return item => item.monthBefore(min) ||
            item.monthAfter(max) ||
            disabledItemHandler(item, { value });
    }
    get disabledItemHandlerWithMinMax() {
        return this.calculateDisabledItemHandlerWithMinMax(this.disabledItemHandler, this.value, this.min, this.max);
    }
    updateHoveredItem(month) {
        if (nullableSame(this.hoveredItem, month, (a, b) => a.monthSame(b))) {
            return;
        }
        this.hoveredItem = month;
        this.hoveredItemChange.emit(month);
    }
    updatePressedItem(item) {
        this.pressedItem = item;
    }
};
TuiCalendarMonthComponent.ɵfac = function TuiCalendarMonthComponent_Factory(t) { return new (t || TuiCalendarMonthComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_CALENDAR_MONTHS)); };
TuiCalendarMonthComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiCalendarMonthComponent, selectors: [["tui-calendar-month"]], hostVars: 2, hostBindings: function TuiCalendarMonthComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_single", ctx.isSingle);
    } }, inputs: { value: "value", year: "year", disabledItemHandler: "disabledItemHandler", min: "min", max: "max" }, outputs: { monthClick: "monthClick", hoveredItemChange: "hoveredItemChange", yearChange: "yearChange" }, decls: 3, vars: 2, consts: [["class", "t-scrollbar", 4, "ngIf", "ngIfElse"], ["monthSelect", ""], [1, "t-scrollbar"], [3, "min", "max", "initialItem", "value", "yearClick"], [3, "focusable", "leftDisabled", "rightDisabled", "leftClick", "rightClick"], ["tuiLink", "", 3, "tuiFocusable", "click"], [1, "t-row"], [4, "ngFor", "ngForOf"], ["class", "t-cell", 3, "t-cell_today", "t-cell_interval", "tuiHoveredChange", "tuiPressedChange", "click", 4, "tuiLet"], [1, "t-cell", 3, "tuiHoveredChange", "tuiPressedChange", "click"], [1, "t-item"]], template: function TuiCalendarMonthComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiCalendarMonthComponent_tui_scrollbar_0_Template, 2, 4, "tui-scrollbar", 0);
        ɵngcc0.ɵɵtemplate(1, TuiCalendarMonthComponent_ng_template_1_Template, 6, 8, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isYearPickerShown)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiScrollbarComponent, ɵngcc2.TuiPrimitiveYearPickerComponent, ɵngcc2.TuiPrimitiveSpinButtonComponent, ɵngcc2.TuiLinkComponent, ɵngcc3.TuiFocusableDirective, ɵngcc1.NgForOf, ɵngcc3.TuiLetDirective, ɵngcc3.TuiHoveredDirective, ɵngcc3.TuiPressedDirective], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-m)}.t-row[_ngcontent-%COMP%]{position:relative;z-index:0;display:flex;justify-content:space-between;height:2.25rem}.t-item[_ngcontent-%COMP%]{position:relative;flex:1;line-height:2rem;border-radius:var(--tui-radius-m)}.t-item[_ngcontent-%COMP%]:after, .t-item[_ngcontent-%COMP%]:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;width:3.6875rem;text-align:center;outline:0;cursor:pointer;background-clip:content-box;box-sizing:border-box;border:2px solid transparent;box-sizing:content-box}.t-cell[_ngcontent-%COMP%]:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell_today[_ngcontent-%COMP%]:after{position:absolute;left:50%;transform:translate(-50%,0);content:'';bottom:.3125rem;height:.125rem;width:.75rem;border-radius:.375rem;background-color:var(--tui-text-02)}.t-cell_interval[_ngcontent-%COMP%]:before{background:var(--tui-base-02)}._single[_nghost-%COMP%]   .t-cell_interval[_ngcontent-%COMP%]:before{background:var(--tui-secondary-hover)}.t-cell_interval[_ngcontent-%COMP%]:not(:last-child):before{right:-3.6875rem}.t-cell_interval[_ngcontent-%COMP%]:last-child:first-child:before{right:0}.t-cell_interval[_ngcontent-%COMP%]:first-child > .t-item[_ngcontent-%COMP%]{border-top-left-radius:var(--tui-radius-m);border-bottom-left-radius:var(--tui-radius-m)}.t-cell_interval[_ngcontent-%COMP%]:last-child > .t-item[_ngcontent-%COMP%]{border-top-right-radius:var(--tui-radius-m);border-bottom-right-radius:var(--tui-radius-m)}.t-cell_interval[_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{border-radius:0}.t-cell[data-range][_ngcontent-%COMP%]:after{background-color:var(--tui-primary-text)}.t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{color:var(--tui-primary-text)}.t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary)}.t-cell[data-range][data-state=hovered][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][data-state=hovered][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary-hover)}.t-cell[data-range][data-state=pressed][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][data-state=pressed][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary-active)}.t-cell[data-range=end][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{left:.25rem}.t-cell[data-range=end][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after{left:-2rem;right:100%;transform:translateX(1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-range=start][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{right:.25rem}.t-cell[data-range=start][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after{left:100%;right:-2rem;transform:translateX(-1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-state=disabled][_ngcontent-%COMP%]{pointer-events:none}.t-cell[data-state=disabled][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{opacity:.36}.t-cell[data-state=hovered][_ngcontent-%COMP%]:hover:not([data-range]) > .t-item[_ngcontent-%COMP%]{background-color:var(--tui-secondary-hover)}.t-cell[data-state=pressed][_ngcontent-%COMP%]:hover:not([data-range]) > .t-item[_ngcontent-%COMP%]{background-color:var(--tui-secondary-active)}[_nghost-%COMP%]{display:block;height:13.625rem;width:15.75rem;padding:1.125rem;box-sizing:content-box}.t-row[_ngcontent-%COMP%]{flex-wrap:wrap;margin-top:1.4375rem}.t-cell[_ngcontent-%COMP%]:nth-child(n+5){margin-top:1.75rem}.t-cell_interval[_ngcontent-%COMP%]:nth-child(4n):before{right:0}.t-scrollbar[_ngcontent-%COMP%]{height:inherit;width:inherit}"], changeDetection: 0 });
TuiCalendarMonthComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_CALENDAR_MONTHS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarMonthComponent.prototype, "value", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarMonthComponent.prototype, "year", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarMonthComponent.prototype, "disabledItemHandler", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarMonthComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarMonthComponent.prototype, "max", void 0);
__decorate([
    Output()
], TuiCalendarMonthComponent.prototype, "monthClick", void 0);
__decorate([
    Output()
], TuiCalendarMonthComponent.prototype, "hoveredItemChange", void 0);
__decorate([
    Output()
], TuiCalendarMonthComponent.prototype, "yearChange", void 0);
__decorate([
    HostBinding('class._single')
], TuiCalendarMonthComponent.prototype, "isSingle", null);
__decorate([
    tuiPure
], TuiCalendarMonthComponent.prototype, "calculateDisabledItemHandlerWithMinMax", null);
TuiCalendarMonthComponent = __decorate([ __param(0, Inject(TUI_CALENDAR_MONTHS))
], TuiCalendarMonthComponent);

let TuiCalendarMonthModule = class TuiCalendarMonthModule {
};
TuiCalendarMonthModule.ɵfac = function TuiCalendarMonthModule_Factory(t) { return new (t || TuiCalendarMonthModule)(); };
TuiCalendarMonthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiCalendarMonthModule });
TuiCalendarMonthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiPrimitiveYearPickerModule,
            TuiPrimitiveSpinButtonModule,
            TuiScrollbarModule,
            TuiLinkModule,
            TuiLetModule,
            TuiHoveredModule,
            TuiPressedModule,
            TuiFocusableModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiCalendarMonthComponent, [{
        type: Component,
        args: [{
                selector: 'tui-calendar-month',
                template: "<tui-scrollbar\n    *ngIf=\"isYearPickerShown; else monthSelect\"\n    class=\"t-scrollbar\"\n>\n    <tui-primitive-year-picker\n        [min]=\"min\"\n        [max]=\"max\"\n        [initialItem]=\"year\"\n        [value]=\"value\"\n        (yearClick)=\"onPickerYearClick($event)\"\n    ></tui-primitive-year-picker>\n</tui-scrollbar>\n<ng-template #monthSelect>\n    <tui-primitive-spin-button\n        [focusable]=\"false\"\n        [leftDisabled]=\"previousYearDisabled\"\n        [rightDisabled]=\"nextYearDisabled\"\n        (leftClick)=\"onPreviousYear()\"\n        (rightClick)=\"onNextYear()\"\n    >\n        <button\n            tuiLink\n            [tuiFocusable]=\"false\"\n            (click)=\"onYearClick()\"\n        >\n            {{ year.formattedYear }}\n        </button>\n    </tui-primitive-spin-button>\n    <div class=\"t-row\">\n        <ng-container *ngFor=\"let month of months$ | async; let index = index\">\n            <div\n                *tuiLet=\"getTuiMonth(index, year.year) as item\"\n                class=\"t-cell\"\n                [class.t-cell_today]=\"isItemToday(item)\"\n                [class.t-cell_interval]=\"isItemInsideRange(item)\"\n                [attr.data-range]=\"getItemRange(item)\"\n                [attr.data-state]=\"getItemState(item)\"\n                (tuiHoveredChange)=\"onItemHovered($event, item)\"\n                (tuiPressedChange)=\"onItemHovered($event, item)\"\n                (click)=\"onItemClick(item)\"\n            >\n                <div class=\"t-item\">{{ month }}</div>\n            </div>\n        </ng-container>\n    </div>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{font:var(--tui-font-text-m)}.t-row{position:relative;z-index:0;display:flex;justify-content:space-between;height:2.25rem}.t-item{position:relative;flex:1;line-height:2rem;border-radius:var(--tui-radius-m)}.t-item:after,.t-item:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell{position:relative;display:flex;align-items:center;justify-content:center;width:3.6875rem;text-align:center;outline:0;cursor:pointer;background-clip:content-box;box-sizing:border-box;border:2px solid transparent;box-sizing:content-box}.t-cell:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell_today:after{position:absolute;left:50%;transform:translate(-50%,0);content:'';bottom:.3125rem;height:.125rem;width:.75rem;border-radius:.375rem;background-color:var(--tui-text-02)}.t-cell_interval:before{background:var(--tui-base-02)}:host._single .t-cell_interval:before{background:var(--tui-secondary-hover)}.t-cell_interval:not(:last-child):before{right:-3.6875rem}.t-cell_interval:last-child:first-child:before{right:0}.t-cell_interval:first-child>.t-item{border-top-left-radius:var(--tui-radius-m);border-bottom-left-radius:var(--tui-radius-m)}.t-cell_interval:last-child>.t-item{border-top-right-radius:var(--tui-radius-m);border-bottom-right-radius:var(--tui-radius-m)}.t-cell_interval>.t-item{border-radius:0}.t-cell[data-range]:after{background-color:var(--tui-primary-text)}.t-cell[data-range]>.t-item{color:var(--tui-primary-text)}.t-cell[data-range]>.t-item:after,.t-cell[data-range]>.t-item:before{background-color:var(--tui-primary)}.t-cell[data-range][data-state=hovered]>.t-item:after,.t-cell[data-range][data-state=hovered]>.t-item:before{background-color:var(--tui-primary-hover)}.t-cell[data-range][data-state=pressed]>.t-item:after,.t-cell[data-range][data-state=pressed]>.t-item:before{background-color:var(--tui-primary-active)}.t-cell[data-range=end]>.t-item:before{left:.25rem}.t-cell[data-range=end]>.t-item:after{left:-2rem;right:100%;transform:translateX(1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-range=start]>.t-item:before{right:.25rem}.t-cell[data-range=start]>.t-item:after{left:100%;right:-2rem;transform:translateX(-1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-state=disabled]{pointer-events:none}.t-cell[data-state=disabled]>.t-item{opacity:.36}.t-cell[data-state=hovered]:hover:not([data-range])>.t-item{background-color:var(--tui-secondary-hover)}.t-cell[data-state=pressed]:hover:not([data-range])>.t-item{background-color:var(--tui-secondary-active)}:host{display:block;height:13.625rem;width:15.75rem;padding:1.125rem;box-sizing:content-box}.t-row{flex-wrap:wrap;margin-top:1.4375rem}.t-cell:nth-child(n+5){margin-top:1.75rem}.t-cell_interval:nth-child(4n):before{right:0}.t-scrollbar{height:inherit;width:inherit}"]
            }]
    }], function () { return [{ type: ɵngcc4.Observable, decorators: [{
                type: Inject,
                args: [TUI_CALENDAR_MONTHS]
            }] }]; }, { value: [{
            type: Input
        }], year: [{
            type: Input
        }], disabledItemHandler: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], monthClick: [{
            type: Output
        }], hoveredItemChange: [{
            type: Output
        }], yearChange: [{
            type: Output
        }], isSingle: [{
            type: HostBinding,
            args: ['class._single']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiCalendarMonthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiPrimitiveYearPickerModule,
                    TuiPrimitiveSpinButtonModule,
                    TuiScrollbarModule,
                    TuiLinkModule,
                    TuiLetModule,
                    TuiHoveredModule,
                    TuiPressedModule,
                    TuiFocusableModule,
                ],
                declarations: [TuiCalendarMonthComponent],
                exports: [TuiCalendarMonthComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiCalendarMonthModule, { declarations: function () { return [TuiCalendarMonthComponent]; }, imports: function () { return [CommonModule,
        TuiPrimitiveYearPickerModule,
        TuiPrimitiveSpinButtonModule,
        TuiScrollbarModule,
        TuiLinkModule,
        TuiLetModule,
        TuiHoveredModule,
        TuiPressedModule,
        TuiFocusableModule]; }, exports: function () { return [TuiCalendarMonthComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiCalendarMonthComponent, TuiCalendarMonthModule };

